import React, { useRef } from 'react';
import { TieredMenu } from 'primereact/tieredmenu';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import '../contextMenu/contextmenu.css';

const TieredMenuButton = ({ btnColor = 'white', icon = 'ellipsis', iconColor = '#000', menuModel, modelProps = {}, buttonClass = '', style = {}, showLabel = false, title }) => {
  const menuRef = useRef(null);

  const getMenuModel = () => {
    let model = menuModel ? menuModel(modelProps) : [];
    if (Array.isArray(model) && model.length === 1 && model[0]?.label && Array.isArray(model[0]?.items)) {
      if (showLabel) {
        const headerLabel = model[0].label;
        return [
          {
            template: () => (
              <div
                className="p-submenu-header"
                style={{ fontWeight: "700", padding: "0.75rem 1.25rem", color: "#343a40", userSelect: "none" }}
              >
                {headerLabel}
              </div>
            ),
            disabled: true
          },
          ...(model?.[0]?.items || [])
        ];
      }
      return model?.[0]?.items || [];
    }
    return model || [];
  };

  return (
    <>
      <button
        type="button"
        className={`btn btn-default bg-${btnColor} btn-circle btn-my ${buttonClass}`}
        style={{ margin: '0px 2px 2px 2px', ...style }}
        onClick={(e) => menuRef.current.toggle(e)}
        title={title}
      >
        <i className={`fa fa-${icon} fa-fw img-circle`} style={{ color: iconColor }}></i>
      </button>

      <TieredMenu model={getMenuModel()} popup ref={menuRef} />
    </>
  );
};

export default TieredMenuButton;
